export function ProductOriginIcon(props) {
  return (
    


<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" class="-mt-0.5 h-6 w-6 flex-shrink-0 text-blue-1000"><path stroke-linecap="round" stroke-linejoin="round" d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>

  );
}

ProductOriginIcon.defaultProps = {
  width: "20",
  height: "20",
};


